'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');

var template = require('modules/collection/templates/components/filter/previous-owners.hbs');

var PreviousOwnersView = FilterComponentView.extend({
    template: template,

    ui: {
        'multipleOptions': '.component-filter-buttons input[type="checkbox"]',
        'multipleOptionsSelect': '.filter-select select',
        'clearSelect': '.clear-select',
    },

    events: {
        'change @ui.multipleOptions': 'change',
        'change @ui.multipleOptionsSelect': 'change',
        'click @ui.clearSelect': 'clearSelect',
    },

    commonPreviousOwners: [],

    previousOwners: [],

    viewData: {
        commonPreviousOwners: function() {
            return this.commonPreviousOwners.concat([{type: 'undefined', displayName: 'undefined'}]);
        },

        previousOwners: function() {
            return this.previousOwners;
        },
    },

    initialize: function(options) {
        FilterComponentView.prototype.initialize.apply(this, arguments);

        this.commonPreviousOwners = this.getCommonValues(4);

        this.previousOwners = _.filter(this.getSortedValues(), function(item){
            return !_.contains(_.pluck(this.commonPreviousOwners, 'type'), item.type)
        }.bind(this));
    },

    clearSelect: function(event) {
        this.ui.multipleOptionsSelect.find('option:first').prop('selected', true);

        this.change();

        //@todo investigate who calls navigate on button if default is not prevented
        event ? event.preventDefault() : null;
    },

    getFilters: function() {
        var filters = [];

        var multipleOptions = this.ui.multipleOptions.filter(':checked');

        multipleOptions.each(function(index, option){
            option = $(option);
            filters.push({value: option.val(), displayName: option.next('label').text().trim()});
        });

        var select = this.ui.multipleOptionsSelect;
        if (select.val()) {
            filters.push({value: select.val(), displayName: select.find('option:selected').text()});
        }

        return filters;
    },

    setFilters: function(filters) {
        filters = filters.split(',');

        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', _.contains(filters, $(option).val()));
        });

        this.ui.multipleOptionsSelect.closest('.filter-select').removeClass('active');

        this.ui.multipleOptionsSelect.find('option').each(function(index, option){
            $(option).prop('selected', _.contains(filters, $(option).val()));
        });

        if (this.ui.multipleOptionsSelect.val()) {
            this.ui.multipleOptionsSelect.closest('.filter-select').addClass('active');
        }
    },

    resetFilters: function() {
        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', false);
        });

        this.clearSelect();

        this.change();
    },

    getSortedValues: function() {
        if (!this.sortedValues) {
            var sortedValues = {};

            this.collection.each(function(model){
                var previousOwner = _.last(_.pluck(model.get('objectHistory'), 'from'));
                if (previousOwner) {
                    if (sortedValues[previousOwner]) {
                        sortedValues[previousOwner].count++
                    } else {
                        sortedValues[previousOwner] = {
                            count: 1,
                            type: previousOwner,
                            displayName: previousOwner,
                        }
                    }
                }
            });

            this.sortedValues = _.sortBy(sortedValues, function(item) { return item.count * -1; });
        }

        return this.sortedValues;
    },

    getFilterValueDisplayName: function(value) {
        // var values = this.getSortedValues();
        // var owner = _.findWhere(values, {type: value});

        // return  owner ? owner.displayName : value;
        return value;
    },
});

module.exports = PreviousOwnersView;